import { getSessionTeamType } from './getTeamType';

export const isBrokerOrFlexpert = () => {
  const teamType = getSessionTeamType();

  return teamType === 'Broker' || teamType === 'Flexpert Support';
};
